import React from 'react';
import { AlertCircle, AlertTriangle, TrendingDown, Users } from 'lucide-react';
import { Badge } from '../ui/Badge';
interface Alert {
  id: string;
  type: 'critical' | 'warning' | 'info';
  message: string;
  icon: React.ReactNode;
  actionLabel?: string;
  onAction?: () => void;
}
export function AlertBanner() {
  // Mock alerts - in real app, these would be calculated from actual data
  const alerts: Alert[] = [{
    id: '1',
    type: 'critical',
    message: '12 deals have been in "Docs Out" stage for >7 days',
    icon: <AlertCircle className="h-5 w-5" data-id="element-1" />,
    actionLabel: 'View Details',
    onAction: () => console.log('View stalled deals')
  }, {
    id: '2',
    type: 'warning',
    message: 'James Wilson at 95% capacity (22 active applications)',
    icon: <Users className="h-5 w-5" data-id="element-2" />,
    actionLabel: 'Reassign',
    onAction: () => console.log('Reassign deals')
  }, {
    id: '3',
    type: 'warning',
    message: 'Submission rate down 15% vs last week',
    icon: <TrendingDown className="h-5 w-5" data-id="element-3" />,
    actionLabel: 'Analyze',
    onAction: () => console.log('Analyze trend')
  }];
  if (alerts.length === 0) return null;
  const getAlertStyles = (type: Alert['type']) => {
    switch (type) {
      case 'critical':
        return 'bg-red-50 border-red-200 text-red-800';
      case 'warning':
        return 'bg-amber-50 border-amber-200 text-amber-800';
      case 'info':
        return 'bg-blue-50 border-blue-200 text-blue-800';
    }
  };
  const getIconColor = (type: Alert['type']) => {
    switch (type) {
      case 'critical':
        return 'text-red-500';
      case 'warning':
        return 'text-amber-500';
      case 'info':
        return 'text-blue-500';
    }
  };
  return <div className="space-y-3" data-id="element-4">
      {alerts.map(alert => <div key={alert.id} className={`flex items-center justify-between p-4 rounded-lg border-2 ${getAlertStyles(alert.type)} transition-all hover:shadow-sm`} data-id="element-5">
          <div className="flex items-center gap-3 flex-1" data-id="element-6">
            <div className={getIconColor(alert.type)} data-id="element-7">{alert.icon}</div>
            <div className="flex items-center gap-3 flex-1" data-id="element-8">
              <span className="text-sm font-medium" data-id="element-9">{alert.message}</span>
              {alert.type === 'critical' && <Badge variant="danger" size="sm" data-id="element-10">
                  Action Required
                </Badge>}
            </div>
          </div>
          {alert.actionLabel && alert.onAction && <button onClick={alert.onAction} className="ml-4 px-3 py-1.5 text-xs font-medium rounded-md bg-white border border-gray-300 hover:bg-gray-50 transition-colors whitespace-nowrap" data-id="element-11">
              {alert.actionLabel}
            </button>}
        </div>)}
    </div>;
}